/* @fflow */
import React from 'react';
import { Row } from 'components/UIKit/Flex';
import TransactionTypeFilter from './TransactionTypeFilter';
import TransactionStepFilter from './TransactionStepFilter';
import TransactionStateFilter from './TransactionStateFilter';

function TransactionsToolbar({
  router,
}): React.Element {
  const { state, type, isDryRun, committable, closed, ...query } = router.location.query;

  return (
    <Row style={{ alignItems: 'center', marginRight: '2rem' }}>
      <TransactionStateFilter
        type={type}
        closed={closed}
        committable={committable}
        isDryRun={isDryRun}
        query={query}
        state={state}
      />
      <TransactionTypeFilter
        style={{ marginLeft: '1rem' }}
        type={type}
        isDryRun={isDryRun}
        query={query}
        state={state}
      />
      <TransactionStepFilter
        style={{ marginLeft: '1rem' }}
        isDryRun={isDryRun}
        type={type}
        query={query}
        state={state}
      />
    </Row>
  );
}

export default TransactionsToolbar;
